import { blue, blueDark } from '@ant-design/colors';
import type { ThemeConfig } from 'antd';
import { GetCustomToken } from 'antd-style';

const themePrimaryColor = blue;
const themePrimaryDarkColor = blueDark;

export const themeConfig: ThemeConfig = {
  hashed: false,
  cssVar: true,
  token: {
    colorPrimary: themePrimaryColor.primary,
    borderRadius: 6,
  },
  components: {
    Typography: {
      titleMarginBottom: 0,
    },
  },
};

/**light */
export const customTokenDefault = {
  adminHeaderHeight: 64,
  adminSiderWitdh: 180,
  primary10: themePrimaryColor[9],
  primary9: themePrimaryColor[8],
  primary8: themePrimaryColor[7],
  primary7: themePrimaryColor[6],
  primary6: themePrimaryColor.primary,
  primary5: themePrimaryColor[4],
  primary4: themePrimaryColor[3],
  primary3: themePrimaryColor[2],
  primary2: themePrimaryColor[1],
  primary1: themePrimaryColor[0],
};

/**dark */
export const customTokenDark = {
  primary10: themePrimaryDarkColor[9],
  primary9: themePrimaryDarkColor[8],
  primary8: themePrimaryDarkColor[7],
  primary7: themePrimaryDarkColor[6],
  primary6: themePrimaryDarkColor.primary,
  primary5: themePrimaryDarkColor[4],
  primary4: themePrimaryDarkColor[3],
  primary3: themePrimaryDarkColor[2],
  primary2: themePrimaryDarkColor[1],
  primary1: themePrimaryDarkColor[0],
};

export type AppCustomToken = typeof customTokenDefault;

// 通过给 antd-style 扩展 CustomToken 对象类型定义，可以为 useTheme 中增加相应的 token 对象
declare module 'antd-style' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface CustomToken extends AppCustomToken {}
}

export const createCustomToken: GetCustomToken<AppCustomToken> = ({ token, isDarkMode }) => {
  return !isDarkMode ? customTokenDefault : { ...customTokenDefault, ...customTokenDark };
};
